import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";

export const COMPETITION_META = {
  "/competition/VirtualRobot": {
    description: "Design, code, and compete in a virtual robotics arena.",
    icon: SmartToyOutlinedIcon,
  },
  "/competition/Robomission": {
    description: "Complete themed missions with an autonomous robot.",
    icon: PrecisionManufacturingOutlinedIcon,
  },
  "/competition/RobomissionKids": {
    description: "Entry-level robot missions built for young learners.",
    icon: SmartToyOutlinedIcon,
  },
  "/competition/Followline": {
    description: "Build a robot that follows paths with speed and precision.",
    icon: RouteOutlinedIcon,
  },
  "/competition/roboGuard": {
    description: "Program defensive strategies in a tactical robot challenge.",
    icon: ShieldOutlinedIcon,
  },
  "/competition/Researchers": {
    description: "Present a scientific project with creativity and curiosity.",
    icon: ScienceOutlinedIcon,
  },
  "/competition/Scientific": {
    description: "Research, experiment, and showcase innovative STEM ideas.",
    icon: ScienceOutlinedIcon,
  },
};

const CATEGORY_TYPE_INFO = {
  Researchers: {
    accent: "#23aef4",
    title: "We Do Researchers",
  },
  "Engineers & Pioneers": {
    accent: "#c11a83",
    title: "We Do Engineers & Pioneers",
  },
};

export const getCompetitionCategoryInfo = (type) =>
  CATEGORY_TYPE_INFO[type] || {
    accent: "#c11a83",
    title: type || "We Do Challenge",
  };
